const ls = require('local-storage');

const check = (role) => {
    const userRole = ls('user-role');

    let hasPermission = !!userRole && !role; // Allows for elements to show if you have any permissions at all

    if (!userRole) {
        // role is not present in the rules
        return hasPermission;
    }

    if (role) {
        const roles = role.split('|');
        roles.forEach(role => {
            hasPermission |= userRole === role;
        });
    }

    return hasPermission;
};

const Can = props =>
    check(props.role)
        ? props.yes()
        : props.no();

Can.defaultProps = {
    yes: () => null,
    no: () => null
};

export default Can;


// WEBPACK FOOTER //
// ./src/components/Shared/Can.js